import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { preloadPageTitleContentProperties } from '@confluence/content-topper/entry-points/preloadPageTitleContentProperties';
import { preloadArchivedPageBannerV2Queries } from '@confluence/archive-pages/entry-points/preloadArchivedPageBannerV2Queries';

export function preloadContentTitleWithByLine(contentId: string, spaceKey: string) {
	return waitForAllReturnWhenError([
		preloadPageTitleContentProperties({ contentId, spaceKey }),
		preloadArchivedPageBannerV2Queries(contentId),
	]);
}
